'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiAddress2 = function (_React$Component) {
    _inherits(AiAddress2, _React$Component);

    function AiAddress2() {
        _classCallCheck(this, AiAddress2);

        return _possibleConstructorReturn(this, (AiAddress2.__proto__ || Object.getPrototypeOf(AiAddress2)).apply(this, arguments));
    }

    _createClass(AiAddress2, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M14,31.994c0.151-0.181,0.278-0.391,0.456-0.54c1.591-1.333,3.194-2.652,4.789-3.981c2.065-1.721,4.124-3.45,6.189-5.172 c1.61-1.342,3.23-2.67,4.835-4.018c0.942-0.792,2.524-0.795,3.477,0.011c1.739,1.471,3.493,2.924,5.241,4.384 c0.028,0.023,0.061,0.038,0.14,0.087c0.01-0.132,0.024-0.228,0.024-0.325c0.002-1.255,0-2.511,0.002-3.766 c0.001-0.718,0.225-0.936,0.95-0.936c1.275,0,2.549,0,3.824,0c0.699,0,0.929,0.23,0.929,0.931c0.001,2.856,0.004,5.712-0.005,8.568 c-0.001,0.236,0.076,0.392,0.251,0.537c1.477,1.217,2.952,2.435,4.419,3.664c0.185,0.155,0.321,0.37,0.479,0.558 c0,0.134,0,0.268,0,0.403c-0.458,0.561-0.915,1.122-1.373,1.682c-0.448,0.549-0.793,0.6-1.335,0.155 c-1.197-0.984-2.383-1.98-3.573-2.972c-1.219-1.017-2.437-2.036-3.655-3.054c-1.322-1.103-2.644-2.206-3.966-3.309 c-1.293-1.079-2.587-2.156-3.876-3.239c-0.16-0.134-0.277-0.137-0.44,0c-1.796,1.506-3.596,3.007-5.397,4.508 c-1.344,1.121-2.692,2.238-4.036,3.36c-1.197,0.999-2.389,2.003-3.586,3.003c-0.69,0.576-1.378,1.154-2.077,1.719 c-0.511,0.413-0.865,0.374-1.279-0.124c-0.473-0.575-0.938-1.155-1.407-1.731C14,32.262,14,32.128,14,31.994z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M44.85,34.372c-0.001-0.147-0.046-0.341-0.145-0.433c-0.363-0.338-0.757-0.643-1.141-0.959 c-1.219-1.003-2.439-2.003-3.657-3.007c-1.203-0.992-2.403-1.987-3.606-2.98c-1.018-0.84-2.036-1.68-3.055-2.518 c-0.412-0.339-0.828-0.672-1.252-1.016c-0.996,0.825-1.974,1.637-2.955,2.446c-1.225,1.01-2.454,2.016-3.679,3.026 c-1.978,1.63-3.952,3.266-5.936,4.889c-0.2,0.164-0.284,0.325-0.284,0.579c0.006,3.431,0.002,6.861,0.005,10.292 c0.001,1.06,0.561,1.62,1.611,1.62c2.683,0.001,5.366,0,8.05,0c0.102,0,0.203,0,0.338,0h5.714c0.157,0,0.261,0,0.365,0 c2.664,0,5.328,0,7.992,0c1.091,0,1.641-0.551,1.642-1.646c0.001-1.581,0.001-3.162,0.001-4.743 C44.856,38.071,44.859,36.222,44.85,34.372z M37.402,41.486c0.406,0.406,0.406,1.065,0,1.471l-0.184,0.184 c-0.406,0.406-1.065,0.406-1.471,0l-3.15-3.15l-3.15,3.15c-0.406,0.406-1.065,0.406-1.471,0l-0.184-0.184 c-0.406-0.406-0.406-1.065,0-1.471l3.15-3.15l-3.15-3.15c-0.406-0.406-0.406-1.065,0-1.471l0.184-0.184 c0.406-0.406,1.065-0.406,1.471,0l3.15,3.15l3.15-3.15c0.406-0.406,1.065-0.406,1.471,0l0.184,0.184 c0.406,0.406,0.406,1.065,0,1.471l-3.15,3.15L37.402,41.486z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '12 12 40 40';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-address-2', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-address-2', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiAddress2;
}(_react2.default.Component);

exports.default = AiAddress2;